import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class CollectItem extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   * @param {Phaser.GameObjects.Container} group
   */
  constructor(scene, x, y, group) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, 'jester_hat');

    this.setOrigin(0);

    this.setup(group);
  }

  setup (group) {
    this.typeId = null;
    this.typeGroupId = null;
    this.scene.physics.add.existing(this);
    group.add(this);
    this.active = false;
    this.visible = false;
    this.body.enable = false;
  }

  spawn (x,y, type) {
    this.setFrame(type.texture);
    this.setOrigin(0);
    this.body.setSize();
    this.typeId = type.id;
    this.typeGroupId = type.type;
    this.itemData = type;
    this.setPosition(x - this.width / 2, y - this.height);
    this.body.reset(this.x, this.y);
    this.body.setVelocity(0);
    this.active = true;
    this.visible = true;
    this.body.enable = true;
  }

  despawn () {
    this.active = false;
    this.visible = false;
    this.body.enable = false;
  }
}